import * as React from "react";
import GalleryImg from "../../../assets/images/setting-gallery-img.png";
interface GalleryPopupProps {
  onClose: () => void;
  imageUrl : string;
  imageName : string;
}

export const GalleryPopupSettings: React.FunctionComponent<GalleryPopupProps> = (
  props
) => {
  return (
    <div className="modal-open">
      <div
        className="detail-poupup bg-white position-fixed top-0 h-100 overflow-auto in"
        style={{ width: "95%" }}
      >
        <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-99">
          <div className="row align-items-center">
            <div
              className="col-auto"
              onClick={() => {
                props.onClose();
              }}
            >
              <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
            </div>
            <div className="col">
              <h5 className="mb-0">{props?.imageName}</h5>
            </div>
          </div>
        </div>
        <div style={{ maxWidth: "1198px" }} className="mx-auto py-5">
          <img src={props?.imageUrl} className="img-fluid w-full" />
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </div>
  );
};
